import { Component, inject, input, model } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Client, ClientSecrets } from '../../../api/types';
import {
  SynButtonComponent,
  SynergyFormsModule, SynIconComponent,
  SynInputComponent,
} from '@synergy-design-system/angular';
import { ServicePortalApi } from '../../../api/api';

@Component({
  selector: 'app-client-credentials',
  template: `
    @if (client().publicClient) {
      <p i18n="@@public-client-warning">
        Public clients do not have client secrets for client authentication.
        Disable "Public Client" in settings to start using client authenitcation or service accounts!
      </p>
    } @else {
      <div class="flex-col gap-1 form-width-large" style="padding-right: 5px;">
        @if (client().serviceAccountEnabled) {
          <syn-input
            [value]="'service-account-' + client().clientId"
            [readonly]="true"
            label="Service Account Username"
            i18n-label="@@service-account-username"
            style="width: 60%"
          />
        }
        <div class="flex-row gap-1">
          <syn-input
            [value]="clientSecrets().secret ?? ''"
            [minlength]="3"
            [maxlength]="100"
            [readonly]="true"
            label="Current Secret"
            i18n-label="@@current-secret"
            name="currentSecret"
            type="password"
            [passwordToggle]="true"
            style="width: 60%"
          />
          <syn-button variant="filled" type="submit" (click)="onRotate()"
                      style="margin-top: auto" class="flex-grow-1"
                      data-e2e="btn-rotate-secret">
            <syn-icon name="refresh_fill" slot="prefix" />
            <span i18n="@@rotate-secret">Rotate Secret</span>
          </syn-button>
        </div>
        <div class="flex-row gap-1">
          <syn-input
            [value]="clientSecrets().rotatedSecret ?? ''"
            [minlength]="3"
            [maxlength]="100"
            [readonly]="true"
            label="Rotated Secret"
            i18n-label="@@rotated-secret"
            name="rotatedSecret"
            type="password"
            [passwordToggle]="true"
            style="width: 60%"
          />
          <syn-button variant="filled" type="submit" (click)="onInvalidate()"
                      style="margin-top: auto" class="flex-grow-1">
            <syn-icon name="delete_fill" slot="prefix" />
            <span i18n="@@invalidate-rotated-secret">Invalidate Rotated Secret</span>
          </syn-button>
        </div>
        <div class="flex-row gap-1">
          @if (clientSecrets().hasRotatedSecret) {
            <span i18n="@@rotated-secret-valid-until">Rotated secret is valid till:</span>
            <span>{{
                clientSecrets().rotatedSecretExpirationTime! * 1000
                  | date : 'yyyy-MM-dd hh:mm:ss'
              }}</span>
          }
        </div>
      </div>
    }
  `,
  styles: [],
  imports: [
    SynInputComponent,
    SynergyFormsModule,
    SynButtonComponent,
    SynIconComponent,
    DatePipe,
  ],
})
export class ClientCredentialsComponent {
  clientSecrets = model.required<ClientSecrets>();
  client = input.required<Client>();

  api = inject(ServicePortalApi);

  onRotate() {
    this.api.rotateSecrets(this.client().id, (newSecrets) => {
      console.log(newSecrets);
      this.clientSecrets.set(newSecrets);
    });
  }

  onInvalidate() {
    this.api.removeRotatedSecret(this.client().id, (newSecrets) => {
      console.log(newSecrets);
      this.clientSecrets.set(newSecrets);
    });
  }
}
